export default {
  developerNivel: {
    JUNIOR_ANALYST: 'Analista Junior',
    ANALYST: 'Analista Pleno',
    SENIOR_ANALYST: 'Analista Sênior'
  },
  gender: {
    MALE: 'Masculino',
    FEMALE: 'Feminino',
    NEUTRAL: 'Neutro'
  },
  taskStatus: {
    TODO: 'Para Fazer',
    DOING: 'Em progresso',
    DONE: 'Finalizado'
  }
}
